module.exports = __webpack_public_path__ + "static/cstoreslider-04-min-bce94e4b373bbeae9d73dd6da6c9834c.jpg";